var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9499 27.8375H11.1124C16.6624 27.8375 19.3374 25.65 19.7999 20.75C19.8499 20.2375 19.4749 19.775 18.9499 19.725C18.4499 19.675 17.9749 20.0625 17.9249 20.575C17.5624 24.5 15.7124 25.9625 11.0999 25.9625H10.9374C5.84986 25.9625 4.04986 24.1625 4.04986 19.075V10.925C4.04986 5.83751 5.84986 4.03751 10.9374 4.03751H11.0999C15.7374 4.03751 17.5874 5.52501 17.9249 9.52501C17.9874 10.0375 18.4249 10.425 18.9499 10.375C19.4749 10.3375 19.8499 9.87501 19.8124 9.36251C19.3874 4.38751 16.6999 2.16251 11.1124 2.16251H10.9499C4.81236 2.16251 2.18736 4.78751 2.18736 10.925V19.075C2.18736 25.2125 4.81236 27.8375 10.9499 27.8375Z",
    fill: "#B3B9CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 15.9375H25.4751C25.9876 15.9375 26.4126 15.5125 26.4126 15C26.4126 14.4875 25.9876 14.0625 25.4751 14.0625H11.2501C10.7376 14.0625 10.3126 14.4875 10.3126 15C10.3126 15.5125 10.7376 15.9375 11.2501 15.9375Z",
    fill: "#B3B9CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6877 20.125C22.9252 20.125 23.1627 20.0375 23.3502 19.85L27.5377 15.6625C27.9002 15.3 27.9002 14.7 27.5377 14.3375L23.3502 10.15C22.9877 9.78749 22.3877 9.78749 22.0252 10.15C21.6627 10.5125 21.6627 11.1125 22.0252 11.475L25.5502 15L22.0252 18.525C21.6627 18.8875 21.6627 19.4875 22.0252 19.85C22.2002 20.0375 22.4502 20.125 22.6877 20.125Z",
    fill: "#B3B9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.060ff50203d4e8d9bbb2a75c00c8ba26.svg";
export { ForwardRef as ReactComponent };